const insuranceCollection = require('od-modules/collections/insurance_catalogue.collection').getInstance();
const ShoppingCart = require('od-modules/cart/cart');

const FLEXIBLE_FARE_RULE = 'FLEXIBLE_FARE_RULE';
const PREMIUM_FARE_RULE = 'PREMIUM_FARE_RULE';
const CANXSELF = 'CANXSELF';
const FLEX_PRODUCTS = ['FLEXSELF', 'FLEXRB160', 'FLEXRB156', 'FLEXUK164', 'FLEX_AX04', 'UKFLEX_AX11'];

const FLEX_THIRD_PARTY = ['FLEXRB160', 'FLEXRB156', 'FLEXUK164', 'FLEX_AX04', 'UKFLEX_AX11'];
const GUARANTEES_AND_FLEX_THIRD_PARTY = ['CANXSELF', 'FLEXSELF', ...FLEX_THIRD_PARTY];

const hasPolicy = (item, policy) => item?.policy === policy;
const getPolicy = ({policy = ''} = {}) => policy;

const shouldGetGuaranteeId = () => !!getPolicy(insuranceCollection.getInsuranceByPolicy(CANXSELF)) &&
    ShoppingCart.take.fareRules((item) => hasPolicy(item, PREMIUM_FARE_RULE)).length === 0 &&
    ShoppingCart.take.insurances((item) => hasPolicy(item, CANXSELF)).length === 0;
const shouldGetFlexThirdPartyId = () => ShoppingCart.take.fareRules((item) => hasPolicy(item, FLEXIBLE_FARE_RULE)).length === 0 &&
    ShoppingCart.take.fareRules((item) => hasPolicy(item, PREMIUM_FARE_RULE)).length === 0 &&
    ShoppingCart.take.insurances((item) => hasPolicy(item, CANXSELF)).length === 0 &&
    ShoppingCart.take.insurances((item) => FLEX_PRODUCTS.includes(item.policy)).length === 0;

const getGuaranteeId = () => GUARANTEES_AND_FLEX_THIRD_PARTY.find((policy) => getPolicy(insuranceCollection.getInsuranceByPolicy(policy)));
const getFlexThirdPartyId = () => FLEX_THIRD_PARTY.find((policy) => getPolicy(insuranceCollection.getInsuranceByPolicy(policy)));

module.exports = {

    getGuaranteeIdBasedOnSessionSelection() {
        let guarantee;
        if (shouldGetGuaranteeId()) {
            guarantee = getGuaranteeId();
        } else if (shouldGetFlexThirdPartyId()) {
            guarantee = getFlexThirdPartyId();
        }
        return guarantee;
    },

};
